import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {colorToRgbaArray} from '@Utils/color.util';
import {rgbaToHexString} from '@Utils/color.util';
import PosterEditorColorPanel from '@Panels/poster-editor-color-panel';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {TranscriptShadowMobileColorPanelProps} from './transcript-shadow-mobile-color-panel.types';
import {getUniqueString} from '@Utils/string.util';
import {useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem';

export function TranscriptShadowMobileColorPanel({panelId = getUniqueString(), ...props}: TranscriptShadowMobileColorPanelProps): ReactElement | null {
  const activeItem = useGetSelectedTranscriptItem();
  const shadowColor = useGetKeyFromSubtitleShadowPropertiesForActiveTranscriptItem('color');

  if (!activeItem || !shadowColor) {
    return null;
  }

  const updateCustomShadowColor = (dropShadowColor: RGBA[], undoable = true): void => {
    void activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        shadow: {
          ...activeItem.getAnySubtitle().toObject().shadow,
          color: rgbaToHexString(dropShadowColor[0]),
        },
      },
      undoable
    );
  };

  return (
    <PosterEditorColorPanel
      headerText={window.i18next.t('pmwjs_shadow')}
      onBackButton={(): void => {
        if (props.onBack) {
          props.onBack();
        }
      }}
      panelId={panelId}
      fillObject={{
        fillType: FillTypes.SOLID,
        fillColor: [colorToRgbaArray(shadowColor)],
      }}
      onChangeColor={updateCustomShadowColor}
      onClose={(): void => {
        props.onClose();
      }}
    />
  );
}
